import { takeEvery, put, call, takeLatest, select } from "redux-saga/effects"
import TYPES from "../types"
import { fetchPageData } from "./api"
import {
    setFilteredData,
    setLoadingState,
    fetchData as fetchTemplateData,
    setModuleData,
    setFilteredDataFetchApi,
    setHistoryLoading,
} from "./actions"
import { selectFilteredData } from "./selectors"
import { setActiveWebsiteData, setModalStatus } from "../actions"
import _ from "lodash"

function* fetchData({ payload, options }) {
    const { page_name } = payload
    const { reUpdateSourceData } = options

    if (payload.page_name == "assets_history") {
        yield put(setHistoryLoading(true))
    } else {
        yield put(setLoadingState(true))
    }
    const response = yield call(fetchPageData, { ...payload, ...options })
    const { data, meta, page_info, statistics } = response
    if (reUpdateSourceData == true) {
        yield put(setFilteredDataFetchApi({ data, page_name }))
    }
    yield put(
        setModuleData({
            module: page_name,
            data,
            meta,
            page_info,
            statistics,
        }),
    )
    if (payload.page_name == "assets_history") {
        yield put(setHistoryLoading(false))
    } else {
        yield put(setLoadingState(false))
    }
}


function* fetchPositionData({ payload, options }) {
    const filteredData = yield select(selectFilteredData)
    yield put(setLoadingState(true))

    const response = yield call(fetchPageData, payload)
    const { data } = response
    const ids = filteredData.map((data) => data.asset_id)
    yield put(setFilteredData(data.filter((data) => ids.includes(data.asset_id))))
    yield put(setLoadingState(false))
}


function* openWebsite({ payload }) {

    yield put(
        setActiveWebsiteData({
            website: payload,
        }),
    )
}

function* TemplateDataSaga() {
    yield takeEvery(TYPES.FETCH_MODULE_TEMPLATE_DATA, fetchData)
    yield takeEvery(TYPES.FETCH_MODULE_TEMPLATE_UPDATE_POSITION_DATA, fetchPositionData)
    yield takeEvery(TYPES.WEBSITE, openWebsite)
}

export default TemplateDataSaga
